// extracted by mini-css-extract-plugin
export var contrastLow = "_3w-1";
export var externalLink = "_3w-2";
export var externalLinkIcon = "_3w-3";
export var link = "_3w-0";
export var linkLabel = "_3w-4";